<template>
  <div class="resources-feed">
    <Hero :title="title" :subtitle="subtitle" />
    <Search />
    <Filters />
    <Feed />
  </div>
</template>

<script>
import store from './store/store';
import Filters from './components/Filters';
import Hero from './components/Hero';
import Search from './components/Search';
import Feed from './components/Feed';
export default {
  name: 'ResourcesFeed',
  store: store,
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),
  methods: {},
  mounted () {},
  components: {
    Hero,
    Filters,
    Search,
    Feed
  }
};
</script>

<style></style>
